// src/features/pois/peopleVisits.js
//
// The People tab of a POI's Visit History: GET /api/pois/:id/staff-visits
// returns staff dwell visits and the Work stops completed at the POI; the tab
// shows them as one timeline. Pure, so it is unit-tested.

/** One row per visit / completed stop, `at` = arrival or completion instant. */
export function peopleTimeline({ visits = [], stops = [] } = {}, { userId = 'all', order = 'desc' } = {}) {
  const rows = [
    ...visits.map((v) => ({ type: 'visit', key: `v:${v.userId}:${v.arrivedAt}`, at: v.arrivedAt, userId: v.userId, userName: v.userName, visit: v })),
    ...stops.map((s) => ({ type: 'stop', key: `s:${s.id}`, at: s.completed_at, userId: s.user_id, userName: s.user_name, stop: s })),
  ].filter((r) => userId === 'all' || r.userId === userId);
  const sign = order === 'asc' ? 1 : -1;
  return rows.sort((a, b) => sign * (Date.parse(a.at) - Date.parse(b.at)));
}

/** [[userId, name]] of everyone in the data, by name — the person filter's options. */
export function peopleOptions({ visits = [], stops = [] } = {}) {
  const seen = new Map();
  for (const v of visits) if (v.userId) seen.set(v.userId, v.userName || v.userId.slice(0, 8));
  for (const s of stops) if (s.user_id && !seen.has(s.user_id)) seen.set(s.user_id, s.user_name || s.user_id.slice(0, 8));
  return [...seen.entries()].sort((a, b) => a[1].localeCompare(b[1]));
}
